import { DeliveryFeeFormValues } from "../components/forms";
import { UpdateDeliveryFeeRequestBody } from "./../apis";

export const getUpdateDeliveryFeeRequestBody = (
  formValues: DeliveryFeeFormValues
): UpdateDeliveryFeeRequestBody => {
  return {
    id: String(formValues.id),
    country: String(formValues.country),
    city: String(formValues.city),
    neighborhood: String(formValues.neighborhood),
    sizeSFee: +formValues.sizeSFee,
    sizeMFee: +formValues.sizeMFee,
    sizeLFee: +formValues.sizeLFee,
    allowCashOnDelivery: formValues.allowCashOnDelivery,
    allowMobileMoney: formValues.allowMobileMoney
  };
};
